// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for DELETE /instagram/accounts/remover/<id>
 *
 * Action endpoint — emits a confirmation message after the account is
 * removed from the upstream service and the local franchise associations
 * are deleted ("Registro removido com sucesso!").
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_RemoverResponseDados {
message: string
}

export type InstagramAccounts_RemoverResponse = ApiResponse<InstagramAccounts_RemoverResponseDados>;

registerResponseContract('InstagramAccounts_RemoverResponse', {
  message: { type: 'string',  required: true },
})
